import { Box } from '@creditas-ui/layout';
import i18n from '../../../i18n';
import { Image, Title, Description } from './SpotlightContent.style';

type SpotlightContentProps = {
  translationKey: string;
  name: string;
  image: string;
  marginTop?: object;
};

const SpotlightContent = ({
  translationKey,
  name,
  image,
  marginTop,
}: SpotlightContentProps): JSX.Element => {
  return (
    <Box marginTop={marginTop}>
      <Image src={image} alt="Status" />
      <Title
        color="neutral.90"
        variant={{
          _: 'headingMdRegular',
          '5xl': 'headingXlLight',
        }}
      >
        {i18n.t(`spotlight:${translationKey}.title`, {
          name,
        })}
      </Title>

      <Description color="neutral.60" variant="bodyLgRegular">
        {i18n.t(`spotlight:${translationKey}.description`)}
      </Description>
    </Box>
  );
};

export { SpotlightContent };
